import { useFormatPenceFactory } from "$routes/_lib/use-format-pence";
import InvoiceType from "$routes/patient/[:patientId]/_lib/invoices/invoice-type";
import { Box, makeStyles } from "@material-ui/core";
import { TransactionType } from "elephant-web/gql";
import { FormattedMessage } from "react-intl";

const useStyles = makeStyles((theme) => ({
  paidSection: {
    marginBottom: theme.spacing(1),
    fontSize: 14,
    fontFamily: theme.typography.fontBold,
    width: "100%",
  },
}));

const Row = ({ name, amount }) => {
  const formatPence = useFormatPenceFactory();
  let printName = name;
  if (name === "PATIENT") {
    printName = "Patient";
  }
  return (
    <Box display="flex" justifyContent="flex-end">
      <strong>{`${printName}: `}</strong>
      {formatPence(amount)}
    </Box>
  );
};

const Paid = ({ invoice }) => {
  const classes = useStyles();
  const formatPence = useFormatPenceFactory();
  const exemptInvoice = invoice?.transactions.filter(
    (t) => t.payer.type === "EXEMPT",
  );
  const totalWaived = invoice.transactions
    .filter((t) => t.payer.type === TransactionType.Waiver)
    .reduce((prevVal, curr) => prevVal + curr.amount.value, 0);

  return (
    <>
      <Box
        display="flex"
        justifyContent="space-between"
        className={classes.paidSection}
      >
        <span>
          <FormattedMessage
            id="invoice.laserReceipt.total"
            defaultMessage="Total"
          />
        </span>
        <span className={classes.totalPaid}>
          {formatPence(invoice.balance.total)}
        </span>
      </Box>
      <Box mt={2}>
        {invoice.payers.map((p) => (
          <>
            <Row name={p.name} amount={p.balance.paid} />
            {exemptInvoice.length > 0 && (
              <Box display="flex" justifyContent="flex-end">
                <strong>
                  <FormattedMessage
                    id="print.invoice.exempt"
                    defaultMessage="Exempt:"
                  />
                </strong>
                <span className={classes.totalPaid}>
                  {formatPence(invoice.balance.total)}
                </span>
              </Box>
            )}
          </>
        ))}
        {totalWaived ? <Row name="Waived" amount={totalWaived} /> : undefined}
      </Box>
    </>
  );
};

Paid.propTypes = {
  invoice: InvoiceType.isRequired,
};

export default Paid;
